import React from 'react';
import {
  GetServerSideProps,
  NextPage,
} from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Layout from '@layout';
import CourseItem from '@component/CourseItem';
import { getCourseList } from '@resources/course';
import { btoa } from '@helpers/string';
import {
  APIHTTPResponseList,
  Course as CourseType,
} from '@type';

interface Props {
  courses: APIHTTPResponseList<CourseType> | null;
}

const Courses: NextPage<Props> = (props: Props) => {
  const { courses } = props;
  const { t } = useTranslation(['course']);

  return (
    <Layout course pageTitle="Algobash Developer - Our Courses">
      <section className="bg-blue-semilight pb-16 pt-36 px-5">
        <h1 className="font-itim text-white text-4xl font-normal text-center mt-8">
          {t('courseTitle')}
        </h1>
        <p className="text-white opacity-70 text-lg my-4 text-center font-normal">
          {t('courseDescription1')}
          <br />
          {t('courseDescription2')}
        </p>
      </section>
      <section className="bg-gray-100 lg:py-10 py-5">
        <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-6 items-start container container-padding mx-auto">
          {courses?.data?.items.map((course) => {
            const id = btoa(course.id.toString());
            const slug = course.name.replaceAll(' ', '-').toLowerCase();

            return (
              <CourseItem
                key={`course-${course.id}`}
                image={course.image}
                title={course.name}
                tags={course.tags}
                modules={course.examList.length}
                level={course.level}
                price={course.fee}
                originalPrice={course.originalFee}
                courseLink={`/courses/${id}/${slug}`}
              />
            );
          })}
        </div>
      </section>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  const { locale = 'en', query } = ctx;
  const pageIndex = parseInt((query.p as string || '1'), 10);

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'course'])),
      courses: (await getCourseList({ itemsPerPage: 9, pageIndex })),
    },
  };
};

export default Courses;
